import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user:JSON.parse(window.localStorage.getItem('user')), //用户信息
    siteinfo:JSON.parse(window.localStorage.getItem('siteinfo')),
  },
  mutations: {
  setUser(state,data){
    state.user = data;
    window.localStorage.setItem('user',JSON.stringify(state.user));
  },
   setSiteinfo(state,data){
    state.siteinfo = data;
     window.localStorage.setItem('siteinfo',JSON.stringify(state.siteinfo));
   }
  },
  actions: {
  },
  modules: {
  }
})
